import React, { useMemo,useContext, PropsWithChildren } from 'react';
import { DataService } from '../../app/services';
import { DataServiceContext } from '../../app/context'
import { ServiceContext } from '@msx/platform-services';

export const AppDataServiceProvider: React.FC<PropsWithChildren<{}>> = (props) => {
  const { httpClient, authClient } = useContext(ServiceContext);
  const dataService = new DataService(httpClient, authClient);

  const dataServiceContainer = useMemo(() => ({
    dataService: dataService,
  }), [dataService]);

  return (
    <DataServiceContext.Provider value={dataServiceContainer}>
      {props.children}
    </DataServiceContext.Provider>
  );
};

// Generated by Copilot
// updated on: 2025-09-17 | 3 lines updated | [Manual] | Added explicit PropsWithChildren typing to ensure proper typing for children after upgrading from React 18.1 to 18.3.1 | Time Taken 2 min
// updated on: 2025-09-26 | 1 line updated | [Auto Generated] | Updated PropsWithChildren typing for React 18.3.1 compatibility | Time Taken 1 min